import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Tag,
  Tooltip,
  Popover,
  Button,
  Row,
  Pagination,
} from "antd";
import GetMerchantInvoices from "../../functions/invoice/getMerchantInvoices";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import MerchantInvoiceAdd from "../../components/modal/merchantInvoiceAdd";
import SearchMerchant from "../../components/search/searcMerchant";
import { FilterOutlined, RedoOutlined } from "@ant-design/icons";
import { useMerchant } from "../../context/merchantContext";
import SearchDatePickerInvoice from "../../components/search/datePickerInvoice";
import SearchPaymentMethodInvoice from "../../components/search/searchPaymentMethodInvoice";
import moneyFormat from "../../functions/utils/moneyFormat";
import requestCallback from "../../functions/invoice/requestCallback";
import TablePagination from "components/pagination/tablePagination";
import dateFormat from "functions/utils/dateFormat";
import GetMerchantActionLog from "functions/merchant/getMerchantActionLog";
import { getMerchantId } from "service/storage";

const MerchantActionLog = () => {
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const { searchFieldsInvoice, setSearchFieldsInvoice } = useMerchant();
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  useEffect(() => {
    prepareQueryStringAndSearch(page, pageSize);
  }, [page, pageSize]);
  useEffect(() => {
    setPage(1);
    prepareQueryStringAndSearch(1, pageSize);
  }, [searchFieldsInvoice]);
  const prepareQueryStringAndSearch = (page, size) => {
    const searchFieldsLength = Object.keys(searchFieldsInvoice).length;
    var queryString = "";
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFieldsInvoice)
        .map((key) => {
          if (!searchFieldsInvoice[key]) return null;
          if (key.includes("At")) {
            // it is date
            return `${key}=${searchFieldsInvoice[key]
              .map((e, i) => {
                if (i === 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFieldsInvoice[key])}`;
        })
        .join("&");
    }
    console.log("queryString", queryString);
    fetchLogs(queryString, page, size);
  };
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 10,
    },
    {
      title: (
        <SearchMerchant title="Тaйлбар" fieldName="description" sort={false} />
      ),
      dataIndex: "description",
      key: "description",
      width: 100,
    },
    {
      title: "IP",
      dataIndex: "ipAddress",
      key: "ipAddress",
      width: 60,
    },
    {
      title: (
        <SearchDatePickerInvoice
          title="Огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: (date) => {
        return <span>{dateFormat(date)}</span>;
      },
    },
  ];

  useEffect(() => {
    refresh();
  }, []);

  const fetchLogs = async (queryString, page, size) => {
    showLoading();
    const merchantId = getMerchantId();
    const response = await GetMerchantActionLog(
      merchantId,
      `page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
    }
  };
  const changePage = (page) => {
    setPage(page);
  };

  const changeSize = (current, size) => {
    setPageSize(size);
  };
  const refresh = () => {
    setPage(1);
  };
  return (
    <div className="vatMerchantListontainer mt-3">
      <div className="tableContainer">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          size="small"
          className="text-xs"
          scroll={{
            x: "max-content",
            y: "calc(100vh - 28vh)",
          }}
          pagination={false}
          dataSource={data}
        ></Table>
        <TablePagination
          page={page}
          paginationData={paginationData}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
    </div>
  );
};

export default MerchantActionLog;
